// extracted by mini-css-extract-plugin
export default {"primarybutton":"PrimaryButton_primarybutton__30hdl"};